import { PageHeader, Section, CTALink } from "@/components/site/PageChrome";
import { EverythingYouNeed, WhyTime2Cash } from "@/components/site/Features";
import { HowItWorks } from "@/components/site/Safety";
import { DownloadSection } from "@/components/site/ClosingBlocks";
import {
  Home as HomeIcon, Briefcase, Building2, ShoppingBag, Store, HeartPulse, Siren, Wallet, MessagesSquare, MapPin, ShieldCheck,
} from "lucide-react";

const detailed = [
  { icon: HomeIcon, t: "Local Needs", d: "Post any daily requirement — from repairs to errands — set a budget and location, and get responses from verified people nearby. Chat, negotiate, and close, all in-app." },
  { icon: Briefcase, t: "Part-Time Jobs", d: "Discover flexible gigs and shifts around your city. Filter by distance, pay, and schedule. Ideal for students, freelancers, and anyone seeking side income." },
  { icon: Building2, t: "Full-Time Jobs", d: "Career opportunities from local businesses looking to hire in your area. Apply directly, no recruiter fees, no spam." },
  { icon: ShoppingBag, t: "Marketplace", d: "Buy, sell, or rent products directly with neighbours. Upload photos, set a price, and connect — zero middlemen, zero commissions." },
  { icon: Store, t: "Local Shops", d: "Explore verified businesses and services near you. See ratings, galleries, and enquire via call, WhatsApp, or in-app chat." },
  { icon: HeartPulse, t: "Blood Requests", d: "Raise or respond to urgent blood requirements. Filter by blood group and hospital to mobilise nearby donors fast." },
  { icon: Siren, t: "SOS Safety", d: "One tap alerts your trusted contacts with your live location trail during emergencies — peace of mind for you and your family." },
  { icon: Wallet, t: "Wallet & Credits", d: "A transparent credits system to post, unlock, and access premium features. Top up, redeem coupons, and manage subscriptions in one place." },
];

const pillars = [
  { icon: MapPin, t: "Hyperlocal by design", d: "Everything is filtered to your neighbourhood, so results are always relevant." },
  { icon: MessagesSquare, t: "Direct communication", d: "Call, chat, or WhatsApp — connect with people directly, no intermediaries." },
  { icon: ShieldCheck, t: "Secure & verified", d: "OTP login and verified business profiles keep the community trustworthy." },
];

export default function FeaturesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Features"
        title="Everything Time2Cash can do."
        subtitle="Eight powerful modules, one seamless app — built for how Indian cities actually live, work, and help each other."
      >
        <CTALink to="/#download" testId="features-download">Download the App</CTALink>
      </PageHeader>

      <Section>
        <div className="grid md:grid-cols-2 gap-6">
          {detailed.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-7 hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center">
                <Icon className="w-6 h-6 text-[#FF5A00]" />
              </div>
              <h3 className="mt-4 text-xl font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-[#4A4846] leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section className="bg-[#FFF9F5]">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">Built on three pillars.</h2>
        </div>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {pillars.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-7 text-center">
              <div className="w-12 h-12 rounded-2xl bg-[#FFF3ED] flex items-center justify-center mx-auto">
                <Icon className="w-6 h-6 text-[#FF5A00]" />
              </div>
              <h3 className="mt-4 text-lg font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-sm text-[#4A4846]">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      <EverythingYouNeed />
      <WhyTime2Cash />
      <HowItWorks />
      <DownloadSection />
    </>
  );
}
